import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { useResourceCount } from '../../hooks/useResourceCount'

import PageHeader from '../../components/ui/pageHeader/PageHeader'
import { BookingHistoryList } from '../../components/authenticated/history/bookingHistoryList/BookingHistoryList'

import { BookingFilter } from '../../types/booking/booking'

const History = () => {
  const { t } = useTranslation('history')
  const [searchParams, setSearchParams] = useSearchParams()
  const requestedTab = searchParams.get('tab')?.toUpperCase()
  const initialTab =
    Object.values(BookingFilter).find(
      filter => filter === requestedTab
    ) ?? BookingFilter.ALL
  const [tab, setTab] = useState(initialTab)
  const { count: bookingsCount } = useResourceCount('/api/v1/bookings/count', {
    filter: tab,
  })

  const filterLabel = t(
    `history.booking-history-list.filter.${tab.toLowerCase()}`
  )

  return (
    <div>
      <PageHeader
        title={{
          eyebrow:
            bookingsCount === null
              ? undefined
              : t('history.page-header.eyebrow', {
                  filterType: filterLabel,
                  bookings: bookingsCount,
                }),
          h1: t('history.page-header.title'),
        }}
        sub={t('history.page-header.sub')}
      />
      <BookingHistoryList
        tab={tab}
        onTabChange={nextTab => {
          setTab(nextTab)
          setSearchParams(
            nextTab === BookingFilter.ALL
              ? {}
              : { tab: nextTab.toLowerCase() }
          )
        }}
      />
    </div>
  )
}

export default History
